import { Button } from "./Button"
import "../components/InnovationSection.css";

export default function InnovationSection() {
  return (
    <section id="innovation" className="innovation-section">
      <div className="innovation-container">
        <div className="innovation-grid">
          <div>
            <img
              src="/pharmaceutical-pills-tablets-medicinal-manufacturi.jpg"
              alt="Manufacturing excellence"
              className="innovation-image"
            />
          </div>
          <div className="innovation-content">
            <h2 className="innovation-heading">Innovation in Pharmaceuticals</h2>
            <p className="innovation-text">
              We invest heavily in research and development to bring cutting-edge pharmaceutical solutions to market.
              Our state-of-the-art manufacturing facilities ensure the highest quality standards.
            </p>
            <ul className="innovation-list">
              {["Advanced Research Facilities", "Quality Assurance", "Sustainable Practices"].map((item) => (
                <li key={item} className="innovation-list-item">
                  <span className="innovation-dot"></span>
                  <span className="innovation-item-text">{item}</span>
                </li>
              ))}
            </ul>
            {/* <Button className="btn-learn-more">Learn More</Button> */}
          </div>
        </div>
      </div>
    </section>
  )
}

